<template>
  <div :class="classObj" class="app-wrapper">
    <!-- <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside" /> -->
    <!-- <sidebar class="sidebar-container" /> -->
    <div class="main-container">
      <!-- 顶部组件 -->
      <div v-if="showNavbar" class="fixed-header">
        <navbar />
      </div>
      <app-main />
    </div>

    <img
      v-if="showCornerWidgets"
      class="kf-img"
      src="@/assets/image/kefu.png"
      alt="客服"
      @click="showCustomerQrcode"
    >
    <img
      v-if="showCornerWidgets"
      class="msg-img"
      src="@/assets/image/news.png"
      alt="消息"
      @click="goToMsg"
    >
    <el-dialog
      title="联系客服"
      :visible.sync="qrcodeDialogVisible"
      width="300px"
      :close-on-click-modal="true"
      center
    >
      <div v-if="qrcodeUrl" style="text-align:center;">
        <img :src="$getImageUrl(qrcodeUrl)" alt="客服二维码" style="width:220px;max-width:100%;margin:0 auto;display:block;">
        <div style="margin-top:10px;color:#999;">微信扫码联系客服</div>
      </div>
      <div v-else style="height:220px;display:flex;align-items:center;justify-content:center;">加载中...</div>
    </el-dialog>
  </div>
</template>

<script>
// import { Navbar, Sidebar, AppMain } from './components'
import { Navbar, AppMain } from './components'
import ResizeMixin from './mixin/ResizeHandler'
import { getCustomerQrcode } from '@/api/home'

export default {
  name: 'Layout',
  components: {
    Navbar,
    // Sidebar,
    AppMain
  },
  mixins: [ResizeMixin],
  data() {
    return {
      qrcodeDialogVisible: false,
      qrcodeUrl: ''
      // ...existing
    }
  },
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    fixedHeader() {
      return this.$store.state.settings.fixedHeader
    },
    showNavbar() {
      // 仅在首页(news_home)不展示顶部导航
      return this.$route.name !== 'news_home'
    },
    showCornerWidgets() {
      // 仅在首页(news_home)不展示消息/客服浮层
      return this.$route.name !== 'news_home'
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    },
    async showCustomerQrcode() {
      this.qrcodeDialogVisible = true
      this.qrcodeUrl = ''
      try {
        const res = await getCustomerQrcode()
        if (res && res.code === 1 && res.data) {
          this.qrcodeUrl = res.data
        } else {
          this.$message && this.$message.error(res?.msg || '获取二维码失败!')
        }
      } catch (e) {
        this.$message && this.$message.error('获取二维码失败!')
      }
    },
    goToMsg() {
      this.$router.push({ path: '/profile/index', query: { activeMenu: '12' }})
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~@/styles/mixin.scss";
  @import "~@/styles/variables.scss";

  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100vh;
    height: 100dvh;
    width: 100%;
    overflow: hidden;
    &.mobile.openSidebar{
      position: fixed;
      top: 0;
    }
  }
  .main-container {
    height: 100vh;
    height: 100dvh;
    overflow: hidden;
  }

  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }

  .fixed-header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1001;
    width: 100%;
  }

  .kf-img{
    width: 56px;
    position: fixed;
    right: 12px;
    bottom: 20px;
    cursor: pointer;
    z-index: 1000;
  }

  .msg-img{
    width: 96px;
    position: fixed;
    right: 8px;
    bottom: 90px;
    cursor: pointer;
    z-index: 1000;
  }

  @media (max-width: 1600px) {
    .kf-img {
      width: 48px;
      right: 10px;
      bottom: 16px;
    }

    .msg-img {
      width: 80px;
      bottom: 76px;
    }
  }

  @media (max-width: 1366px) {
    .kf-img {
      width: 44px;
    }

    .msg-img {
      width: 72px;
      bottom: 68px;
    }
  }
</style>
